module.exports = __webpack_public_path__ + "static/images/bc85c45bde1a5dd7014f3969354dc9be.webp";